import { type MouseEventHandler, useCallback, useState } from 'react'
import type { AppointmentSlotProps } from '../AppointmentSlot'

type LinkClick = MouseEventHandler<HTMLAnchorElement>

export function useActions(props: AppointmentSlotProps) {
  const {
    commitResult,
    result: { resultId },
  } = props

  const [adtlTimesOpen, setAdtlTimesOpen] = useState(false)

  const onClickShow = useCallback<LinkClick>((e) => {
    e.preventDefault()
    e.stopPropagation()
    setAdtlTimesOpen(true)
  }, [])

  const onClickHide = useCallback<LinkClick>((e) => {
    e.preventDefault()
    e.stopPropagation()
    setAdtlTimesOpen(false)
  }, [])

  const onClickAdtlTimes = adtlTimesOpen ? onClickHide : onClickShow

  const onClickResult = useCallback(
    () => commitResult(resultId),
    [commitResult, resultId],
  )
  return {
    onClickResult,
    adtlTimesOpen,
    onClickAdtlTimes,
  }
}
